// test1003
(1003 && 0);
